module.exports = __webpack_public_path__ + "img/bee-robot.118c8c36.svg";